<div [ngClass]="{ 'stand-alone-modal': standAlone }">
    <main class="main-content is-fullwidth" [ngClass]="modalSize">
        <div class="modal is-active" [ngClass]="modalSize">
            <div class="modal-background" (click)="backdropClicked()"></div>
            <div class="modal-content">
                @if (closeActive) {
                    <div class="modal-close is-large" aria-label="close" (click)="closeClicked()"></div>
                }
                <ng-template #insertionComp></ng-template>
            </div>
        </div>
    </main>
</div>
